<template>
  <v-container fluid class="ma-0 pa-0">
    <v-text-field
      :label="$t('formula.fields.name')"
      autocomplete="off"
      type="text"
      v-model="localValue.name"
      :rules="[rules.name]"
      :disabled="disabled"
    />

    <v-text-field
      :label="$t('formula.fields.description')"
      autocomplete="off"
      type="text"
      v-model="localValue.description"
      :disabled="disabled"
    />

    <v-row>
      <v-col cols="12" sm="6" md="2" v-if="!disabled">
        <v-select
          :items="formulaTemplates"
          :label="$t('formula.form.loadTemplate')"
          dense
          filled
          item-text="name"
          item-value="formulaTemplateId"
          @change="loadTemplate"
        />
      </v-col>

      <v-col cols="12" sm="12" :md="disabled ? 6 : 5">
        <v-autocomplete
          v-model="localValue.outputDeveui"
          :items="selectableTags"
          :label="$t('formula.form.outputDeveui')"
          item-text="name"
          item-value="deveui"
          dense
          :rules="[rules.name]"
          @change="loadKeys"
          :disabled="disabled"
          :filter="tagFilter"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title v-html="data.item.name" />
              <v-list-item-subtitle v-html="data.item.deveui" />
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12" :md="disabled ? 6 : 5">
        <v-combobox
          ref="combobox"
          v-model="localValue.outputKey"
          :items="selectableKeys"
          :label="$t('formula.form.outputSensor')"
          item-text="label"
          item-value="key"
          dense
          :rules="[rules.name]"
          @change="updateKey"
          :disabled="disabled"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title v-html="data.item.label" />
              <v-list-item-subtitle v-html="data.item.key" />
            </v-list-item-content>
          </template>
        </v-combobox>
      </v-col>
    </v-row>

    <v-switch
      v-model="localValue.awaitAllInput"
      :label="$t('formula.form.awaitAllInput')"
      :disabled="disabled"
    />

    <v-switch
      v-model="localValue.useTimestampFromTrigger"
      :label="$t('formula.form.useTimestampFromTrigger')"
      :disabled="disabled"
    />

    <v-textarea
      :label="$t('formula.fields.formula')"
      autocomplete="off"
      type="text"
      outlined
      v-model="localValue.value"
      :rules="[rules.name]"
      :hint="$t('formula.fields.formulaHint')"
      :disabled="disabled"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { autoCompleteTagFilter } from "@/_helpers/commonHelper";
export default {
  name: "FormulaInfoForm",

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },

    selectableTags: {
      type: Array,
      default: () => [],
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  model: {
    prop: "value",
  },

  data() {
    return {
      selectableKeys: [],
      rules: {
        name: (v) => !!v || this.$t("validation.requiredSingle"),
      },
    };
  },

  computed: {
    ...mapState("formulas", ["formulaTemplates"]),

    localValue: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    ...mapActions("tag", ["getKeysForTag"]),

    tagFilter(item, queryText) {
      return autoCompleteTagFilter(item, queryText);
    },

    loadTemplate(val) {
      let template = this.formulaTemplates.find(
        (x) => x.formulaTemplateId == val
      );
      if (template == undefined) return;

      this.localValue.name = template.name;
      this.localValue.description = template.description;
      this.localValue.value = template.value;
      this.localValue.awaitAllInput = template.awaitAllInput;
    },

    async loadKeys(deveui) {
      this.selectableKeys = (await this.getKeysForTag({ tagId: deveui })) ?? [];
    },

    updateKey(key) {
      if (key) {
        if (typeof key == "string") {
          this.localValue.outputKey = key;
        }
        if (typeof key == "object" && key.key) {
          this.localValue.outputKey = key.key;
        }
      }
    },
  },

  async created() {
    if (this.localValue.outputDeveui) {
      await this.loadKeys(this.localValue.outputDeveui);
    }
  },
};
</script>
